import {
  getData,
  postData,
  getPromise,
  convertPageModel,
  getFileData
} from './api-base.service'

export const saveStudent = (model) => {
  let data = {
    Id: model.StudentId,
    Phone: model.Phone,
    IsConfigured: model.IsConfigured,
    Name: model.Name,
    UniversityId: model.UniversityId,
    SMSCode: model.Code
  };
  return postData('/Student/Save', data)
}

export const updatePhone = (model) => {
  let data = {
    Id: model.StudentId,
    Phone: model.Phone,
    SMSCode: model.Code
  };
  return postData('/Student/Phone', data);
}

export const updateUniversity = (model) => {
  let data = {
    Id: model.StudentId,
    UniversityId: model.UniversityId
  };
  return postData('/Student/University', data);
}

export const sendRecommendNotifications = (courseCode) => {
  let data = {
    courseCode: courseCode
  };
  return getData('/Student/SendRecommendNotifications', data);
}

export const updateEmailAddress = (model)=>{
  let data = {
    Id: model.StudentId,
    Email: model.Email,
    SMSCode: model.Code
  };
  return postData('/Student/EmailAddress', data);
}

export const getStudent = (studentId) => {
  if (studentId == undefined) {
    return;
  }
  let result = getData('/Student/Get', {
    studentId: studentId
  });
  return result;
}

export const validatePhoneAndCode = (phone, code) => {
  let result = getData('/Student/ValidatePhoneAndCode', {
    phone: phone,
    code: code
  }, false);
  return result;
}

export const getStudentSpeedupCourse = (searchCondition, currentPage, pageSize, orderByField, isSuggestion = false) => {
  let data = {
    phone: searchCondition.phone,
    universityId: searchCondition.universityId,
    isConfigured: searchCondition.isConfigured,
    isEnroll: searchCondition.isEnroll,
    isAuld: searchCondition.isAuld,
    isApplyCourse:searchCondition.isApplyCourse,
    termId: searchCondition.termId,
    courseType: searchCondition.courseType,
    categoryId: searchCondition.categoryId,
    index: currentPage,
    pageSize: pageSize,
    orderByField: orderByField,
    courseCode: searchCondition.courseCode,
    isSuggestion: isSuggestion
  }
  return getData('/Student/SpeedupCourses', data, true, true);
}

export const disableStudent = (studentIdArray) => {
  let data = studentIdArray;
  return postData('/Student/Disable', data);
}
export const enableStudent = (studentIdArray) => {
  let data = studentIdArray;
  return postData('/Student/Enable', data);
}
export const disableStudentAll = (searchCondition) => {
  let data = {
    Phone: searchCondition.phone,
    UniversityId: searchCondition.universityId,
    IsConfigured: searchCondition.isConfigured,
    IsEnroll: searchCondition.isEnroll,
    IsAuld: searchCondition.isAuld,
    IsApplyCourse: searchCondition.isApplyCourse,
    TermId: searchCondition.termId,
    CourseType: searchCondition.courseType,
    CategoryId: searchCondition.categoryId
  }
  return postData('/Student/DisableAll', data);
}
export const enableStudentAll = (searchCondition) => {
  let data = {
    Phone: searchCondition.phone,
    UniversityId: searchCondition.universityId,
    IsConfigured: searchCondition.isConfigured,
    IsEnroll: searchCondition.isEnroll,
    IsAuld: searchCondition.isAuld,
    IsApplyCourse: searchCondition.isApplyCourse,
    TermId: searchCondition.termId,
    CourseType: searchCondition.courseType,
    CategoryId: searchCondition.categoryId
  }
  return postData('/Student/EnableAll', data);
}

export const importStudentSpeedupCourse = () => {
  return postData('/Student/ImportStudentSpeedupCourse');
}

export const getStudentCourseList = (studentId) => {
  let data = {
    studentId: studentId
  };
  let result = getData('/Student/GetStudentCourseList', data);
  return result;
}

export const getStudentCourseupCourseRecords = (studentId) => {
  let data = {
    studentId: studentId
  };
  let result = getData('/Student/GetStudentCourseupCourseRecords', data);
  return result;
}

export const getStudentActiveCourses = () => {
  let result = getData("/Student/GetStudentActiveCourses");
  return result;
}

export const getStudentCurrentTermCourses = (courseCategory, studentId, excludeRefund = false) => {
  let courseCategoryList = [courseCategory];
  return getStudentCurrentTermCoursesForCategories(courseCategoryList, studentId, excludeRefund);
}

export const getStudentCurrentTermCoursesForCategories = (courseCategoryList, studentId, excludeRefund = false, 
  includeOfflineReviewCourse = false) => {
  let data = {
    CourseCategoryList: courseCategoryList,
    StudentId: studentId,
    ExcludeRefund: excludeRefund,
    IncludeOfflineReviewCourse: includeOfflineReviewCourse
  };

  return postData("/Student/GetStudentCurrentTermCourses", data);
}

export const getStudentVocationalTrainingActiveCourses = () => {
  return getData("/Student/GetStudentVocationalTrainingActiveCourses");
}

export const signCourse = (teacherId, courseId,campusId) => {
  let data = {
    teacherId:teacherId,
    courseId:courseId,
    campusId: null
  };
  if (!!campusId){
      data["campusId"] = campusId;
  }
  return getData(`/Student/SignCourse`, data);
}

// export const signVocationalTrainingCourse = (teacherId, courseId) => {
//   return postData(`/Student/SignVocationalTrainingCourse?teacherId=${teacherId}&courseId=${courseId}`);
// }

export const getStudentSignDetail = (teacherId, courseId) => {
  let result = getData(`/Student/SignCourseDetail?teacherId=${teacherId}&courseId=${courseId}`);
  return result;
}

export const getStudentSpeedupCourseAttendanceDetail = (studentId, courseId, termId, campusId) => {
  let data = {
    studentId: studentId,
    courseId: courseId,
    termId: termId
  };
  if (campusId != null && campusId !== undefined && campusId !== '') {
    data.campusId = campusId;
  }
  return getData('/Student/GetStudentSpeedupCourseAttendanceDetail', data);
}

export const getStudentSignSummary = (teacherId, courseId, studentId) => {
  let result = getData(`/Student/SignCourseSummary?teacherId=${teacherId}&courseId=${courseId}&studentId=${studentId}`);
  return result;
}

export const createStudentMemberInfoModel = () => {
  return {
    StudentId: 0,
    UserId: 0,
    FirstName: null,
    LastName: null,
    Name: null,
    Email: null,
    Phone: null,
    BonusPoint: 0,
    Balance: 0,
    BalanceDue: 0,
    AdvanceEnrollmentCount: 0,
    IsMember: false,
    MemberCardNumber: null,
    IsAuId: false
  };
}

export const getStudentMemberInfo = (studentId, phone = "") => {
  let data = {
    studentId: studentId,
    phone: phone
  };
  let result = getData('/Student/MemberInfo', data);
  return result;
}

export const saveStudentFirstName = (studentId, firstName) => {
  return postData(`/Student/SaveFirstName?studentId=${studentId}&firstName=${firstName}`);
}

export const saveStudentLastName = (studentId, lastName) => {
  return postData(`/Student/SaveLastName?studentId=${studentId}&lastName=${lastName}`);
}

export const isStudentEmailValidated = (studentId) => {
  let data = {studentId};
  return getData('/Student/IsStudentEmailValidated', data);
}

export const saveStudentEmail = (studentId, email) => {
  return postData(`/Student/SaveEmail?studentId=${studentId}&email=${email}`);
}

export const supplementStudentInfo = (studentId, firstName, lastName, email) => {
  let data = {
    StudentId: studentId,
    FirstName: firstName,
    LastName: lastName,
    Email: email
  };
  return postData(`/Student/SupplementStudentInfo`, data);
}

export const buyMemberCard = (studentId, memberCardNumber) => {
  return postData(`/Student/BuyMemberCard?studentId=${studentId}&memberCardNumber=${memberCardNumber}`);
}

export const saveStudentBonusPoint = (studentId, bonusPoint,comment) => {
  return postData(`/Student/SaveBonusPoint?studentId=${studentId}&bonusPoint=${bonusPoint}&comment=${comment}`);
}

// export const saveStudentBalance = (studentId, balance, comment) => {
//   return postData(`/Student/SaveBalance?studentId=${studentId}&balance=${balance}&comment=${comment}`);
// }

// export const saveStudentNewBalance = (studentId, balance, comment) => {
//   return postData(`/Student/SaveNewBalance?studentId=${studentId}&balance=${balance}&comment=${comment}`);
// }

// export const saveStudentGiftBalance = (studentId, balance, comment) => {
//   return postData(`/Student/SaveGiftBalance?studentId=${studentId}&balance=${balance}&comment=${comment}`);
// }

export const saveStudentAdvanceEnrollmentCount = (studentId, aeCount) => {
  return postData(`/Student/SaveAdvanceEnrollmentCount?studentId=${studentId}&aeCount=${aeCount}`);
}

export const saveTrainingAdvanceEnrollmentCount = (studentId, aeCount) => {
  return postData(`/Student/SaveTrainingAdvanceEnrollmentCount?studentId=${studentId}&aeCount=${aeCount}`);
}

export const saveStudentSpeedupCourseScore = (id, midtermAverageScore = null, midtermScore = null, courseScoreId = null) => {
  let data = {
    Id: id,
    MidtermAverageScore: midtermAverageScore,
    MidtermScore: midtermScore,
    CourseScoreId: courseScoreId
  };
  return postData(`/Student/SaveSpeedupCourseScore`, data);
}

export const saveStudentSpeedupCoursesScore = (dataList) => {
  let data = dataList;
  return postData(`/Student/SaveSpeedupCoursesScore`, data);
}

export const saveReviewCourseActivation = (id,courseActivationIdList)=>{
  let data = {
    Id : id,
    CourseActivationIdList: courseActivationIdList
  }
  return postData(`/Student/SaveReviewCourseActivation`, data);
}

export const saveStudentSpeedupCourseSignInOnlineDisabled = (id, signInOnlineDisabled) => {
  return postData(`/Student/SaveStudentSpeedupCourseSignInOnlineDisabled?id=${id}&signInOnlineDisabled=${signInOnlineDisabled}`);
}

export const saveStudentSpeedupCourseIsAiCourseEnabled = (id, isAiCourseEnabled) => {
  return postData(`/Student/SaveStudentSpeedupCourseIsAiCourseEnabled?id=${id}&isAiCourseEnabled=${isAiCourseEnabled}`);
}

export const saveStudentSpeedupCourseIsVideoFree = (id, isVideoFree, comment) => {
  if (isVideoFree == 0) {
    isVideoFree = false;
  } else {
    isVideoFree = true;
  }

  return postData(`/Student/SaveStudentSpeedupCourseIsVideoFree?id=${id}&isVideoFree=${isVideoFree}&comment=${comment}`);
}

export const saveStudentSpeedupCourseCampus = (id, campusId) => {
  return postData(`/Student/SaveStudentSpeedupCourseCampus?id=${id}&campusId=${campusId}`);
}

export const saveStudentSupplementVideo = (id, week, supplementVideoType, comment) => {
  let data = {
    StudentSpeedupCourseId:id,
    Week: week,
    SupplementVideoType: supplementVideoType,
    Comment: comment
  };
  return postData('/Student/SaveStudentSupplementVideo', data);
}


export const getStudentPaymentHistory=(studentId)=>{
  let data = {
    studentId: studentId
  };
  let result = getData('/Student/PaymentHistory', data);
  return result;
}

export const getStudentFinacialSummary=(universityId)=>{
  if (typeof universityId == "undefined"){
    universityId = 0;
  }else if (universityId == ''){
    universityId = 0;
  }
  return getData('/Student/StudentFinacialSummary', {universityId: universityId})
}

export const getStudentPaymentReceipt=(accountPaymentId)=>{
  let data = {
    accountPaymentId:accountPaymentId
  }
  return getPromise('/Student/PaymentRecieptPreview',data);
}

export const resetAdvanceEnrollment=(universityId, advanceEnrollmentComment)=>{
  let data ={universityId: universityId, advanceEnrollmentComment: advanceEnrollmentComment};
  return getData('/AdvanceEnrollment/ResetStudentAdvanceEnrollments', data)
}

export const resetStudentAdvanceEnrollmentById=(id)=>{
  let data = {id};
  return getData('/AdvanceEnrollment/ResetStudentAdvanceEnrollmentById', data)
}

export const resetTrainingAdvanceEnrollment=()=>{
  return getData('/Student/ResetTrainingAdvanceEnrollment')
}

export const getStudentBounsPointHistory = (studentId) => {
  let data = {
    studentId: studentId
  };
  let result = getData('/Student/GetStudentBonusPointHistory', data);
  return result;
}

export const getStudentBalanceHistory = (studentId) => {
  let data = {
    studentId: studentId
  };
  let result = getData('/Student/GetStudentBalanceHistory', data);
  return result;
}

export const getStudentSuggestion = (studentId) => {
  let data = {
    studentId: studentId
  };
  let result = getData('/Student/GetStudentSuggestion', data);
  return result;
}

export const getStudentCourseClassInLink = (courseId, campusId) => {
  let data = {
    courseId: courseId,
    campusId: campusId
  };
  let result = getData(`/Student/GetCourseClassInLink`, data);
  return result;
}

export const getStudentReceiptHistory = (studentId) => {
  let data = {
    studentId: studentId
  };
  let result = getData('/Student/GetStudentReceiptHistory', data);
  return result;
}

export const getStudentSearchList = (model) => {
  let data = convertPageModel(model);
  return postData('/Student/GetStudentSearchList', data);
}

export const exportStudentSearchList = (model) => {
  let data = convertPageModel(model);
  return getFileData('/Student/ExportStudentSearchList', data, false);
}

export const exportStudentSearchRawData = (model) => {
  let data = convertPageModel(model);
  return getFileData('/Student/ExportStudentSearchRawData', data, false);
}

export const getStudentVideoDurationSettings = (studentId) => {
  let data = {
    studentId: studentId
  };
  return getData("/Student/GetStudentVideoDurationSettings", data);
}

export const saveStudentBalance = (studentId, amount, balanceType,  isIncreased, comment, id = null) => {
  let data = {
    StudentId: studentId,
    Amount: amount,
    BalanceType: balanceType,
    IsIncreased: isIncreased,
    Comment: comment,
    Id: id
  };
  return postData('/Student/SaveStudentBalance', data);
}


// WEBPACK FOOTER //
// ./src/service/student.service.js